import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão
import { abrirOrcamentoWhats, trazerTituloServicos, trazerRodapePaginasServicos } from '../utils/utils';

const AssistenciaCelular = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Trinco | Serviços de celular";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />


      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.consertoCelular})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Celular</h1>
          <p>Para quem vive conectado.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('celulares')}</h2>
        </article>

        {/* Bloco 1: Telas e Peças */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Tela e Componentes</h3>
            <h4>Troca de tela</h4>
            <p>Substituição da tela danificada.</p>
            <h4>Substituição de componentes</h4>
            <p>Troca de bateria, botões e câmera.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.trocaTelaCelular} alt="Troca de tela de celular" />
          </div>
        </section>

        {/* Bloco 2: Conectores e Limpeza */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Conectores</h3>
            <h4>Troca e reparo</h4>
            <p>Correção do conector de carga e do fone quando o aparelho não carrega ou o áudio falha.</p>
            <h4>Limpeza técnica</h4>
            <p>Limpeza de entradas e câmeras para remover poeira ou umidade.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.limpezaConectorCelular} alt="Limpeza de conectores e câmeras de celular" />
          </div>
        </section>

        {/* Bloco 3: Software, Placas e Proteção */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Funcionamento e Proteção</h3>
            <h4>Atualização de software</h4>
            <p>Correção de falhas e melhoria de desempenho.</p>
            <h4>Reparo de software</h4>
            <p>Solução de travamentos e erros do sistema.</p>
            <h4>Reparo de placa</h4>
            <p>Correção de falhas após queda ou contato com líquidos.</p>
            <h4>Blindagem</h4>
            <p>Proteção reforçada para a tela frontal e fundo.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.reparoPlacaCelular} alt="Reparo de placa de celular" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de celulares')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de celular', document.title)}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default AssistenciaCelular;